/**
 * Bridge between the R3F canvas (which owns the camera) and the DOM drop handler
 * on the editor shell. The in-canvas DropPlacementController registers a
 * resolver that turns client coordinates into a floor-local placement point on
 * the current floor; the shell's onDrop reads it to place a dragged asset.
 */
export interface DropPlacement {
  point: [number, number, number];
  floor: number;
}

type Resolver = (clientX: number, clientY: number) => DropPlacement | null;

let activeResolver: Resolver | null = null;

export function setDropPlacementResolver(resolver: Resolver): void {
  activeResolver = resolver;
}

export function clearDropPlacementResolver(resolver: Resolver): void {
  if (activeResolver === resolver) activeResolver = null;
}

export function resolveDropPlacement(clientX: number, clientY: number): DropPlacement | null {
  return activeResolver ? activeResolver(clientX, clientY) : null;
}
